import script from "./CD4UTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./CD4UTicket.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__